import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import FuseUtils from '@/@fuse/utils';
import SuperAdminConfig from '@/app/main/superadmin/superAdminConfig';
import pagesConfigs from '@/app/main/pages/pagesConfigs';
import subAdminConfig from '@/app/main/subadmin/subAdminConfig';
import secureLocalStorage from 'react-secure-storage';
import FuseLayout from '@/@fuse/core/FuseLayout/FuseLayout';
import RouteAuthGuard from '@/app/auth/RouteAuthGuard';

const publicRoutes = pagesConfigs.filter(
	(config) =>
		config.auth === null ||
		['/login', '/forgot-password', '/reset-password', '/password/reset', '/404', '/500', '/otp', '/success'].some(
			(path) => config.routes.some((route) => route.path === path)
		)
);

const privateRoutes = [
	...pagesConfigs.filter((config) => !publicRoutes.includes(config)),
	...subAdminConfig,
	...SuperAdminConfig,
];

const RootRedirect = () => {
	const role = JSON.parse(secureLocalStorage.getItem('user'))?.role[0];
	if (['super_admin', 'company_owner', 'product_owner'].includes(role)) {
		return <Navigate replace to="/company" />;
	}
	if (['super_school_admin', 'school_admin', 'sub_admin'].includes(role)) {
		return <Navigate replace to="/home" />;
	}
	return <Navigate replace to="/login" />;
};

// Flat private route list — rendered under RootLayout AND handed to
// RouteAuthGuard so its route matching sees exactly what the router does.
const privateChildRoutes = [
	...FuseUtils.generateRoutesFromConfigs(privateRoutes),
	// Root redirect
	{
		path: '/',
		element: <RootRedirect />,
	},
];

// Root layout that will contain all authenticated routes
const RootLayout = () => {
	return (
		<FuseLayout>
			<RouteAuthGuard routes={privateChildRoutes}>
				<Outlet />
			</RouteAuthGuard>
		</FuseLayout>
	);
};

const routes = [
	// Public routes (no layout wrapper)
	...FuseUtils.generateRoutesFromConfigs(publicRoutes),

	// Private routes (with layout wrapper)
	{
		element: <RootLayout />,
		children: privateChildRoutes,
	},
	// 404 route
	{
		path: '*',
		element: <Navigate replace to="/404" />,
	},
];

export default routes;
